module.exports = ".bad {\n  width: 100%;\n  height: calc(100% - 65px);\n}\n.bad .msg {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: auto;\n  max-width: 450px;\n  top: 150px;\n  height: 100vh;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/badrequest/badrequest.component.css
// module id = ./src/app/view/badrequest/badrequest.component.css
// module chunks = main